module.exports = __webpack_public_path__ + "img/2.d4d33c2b.jpg";